import { colors, fonts } from '@grupoboticario/flora-tokens/dist/fidelidadeOBoticario/web/ds'

export const fidelidadeOBoticario = {
  colors,
  fonts,
}
